'use client'

import { z } from 'zod'

import { identityIdSchema } from '@/features/veluvit/schemas/identity.schema'

const TTL_MS = 11 * 60 * 1000
const pendingSchema = z.object({
  id: identityIdSchema,
  userId: z.string().min(1),
  returnPath: z.string().min(1),
  startedAt: z.number().finite(),
})
const keyOf = (id: string) => `veluvit:identity-return:${id}`
export const identityChannelName = (id: string) => `veluvit:identity:${id}`

/** 인증 ID는 서버 값 그대로 사용한다. 개인정보·인증 결과는 기기에 저장하지 않는다. */
export function rememberIdentityAttempt(
  id: string,
  userId: string,
  popup?: Window
) {
  const record = pendingSchema.parse({
    id,
    userId,
    returnPath: location.pathname + location.search + location.hash,
    startedAt: Date.now(),
  })
  const value = JSON.stringify(record)
  try {
    window.sessionStorage.setItem(keyOf(id), value)
  } catch {
    /* 저장 불가 시에도 본창의 서버 조회는 계속한다. */
  }
  // 공급자 화면으로 이동하기 전 같은 출처의 빈 창에 복귀 위치만 복사한다.
  try {
    popup?.sessionStorage.setItem(keyOf(id), value)
  } catch {
    /* opener/채널 연결을 우선 사용한다. */
  }
}

export function readIdentityAttempt(id: string) {
  try {
    const value: unknown = JSON.parse(
      window.sessionStorage.getItem(keyOf(id)) || 'null'
    )
    const parsed = pendingSchema.safeParse(value)
    if (!parsed.success || parsed.data.id !== id) return null
    const age = Date.now() - parsed.data.startedAt
    if (age < 0 || age > TTL_MS) return null
    const target = new URL(parsed.data.returnPath, location.origin)
    if (
      target.origin !== location.origin ||
      target.pathname.startsWith('/identity/')
    )
      return null
    return {
      ...parsed.data,
      returnPath: target.pathname + target.search + target.hash,
    }
  } catch {
    return null
  }
}

export function clearIdentityAttempt(id: string) {
  try {
    window.sessionStorage.removeItem(keyOf(id))
  } catch {
    /* 기기 기록은 권한 판정에 쓰지 않는다. */
  }
}
